// @ts-nocheck
import * as ProjectActionCreators from '../action-creators/project';
import * as KanbanActionCreators from '../action-creators/kanban';
import * as CommentsActionCreators from './comments';
import * as ModalActionCreators from '../action-creators/modal';

export default {
  ...ProjectActionCreators,
  ...KanbanActionCreators,
  ...CommentsActionCreators,
  ...ModalActionCreators,
};
